import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

interface CheckboxProps {
  checked: boolean;
  color: string;
}

export const Svg = styled.svg<BackgroundElement>`
  flex-shrink: 0;
  min-width: 18px;
  min-height: 18px;
  color: ${props => props.color};
`;

export const Checkbox = ({
  checked,
  color,
}: CheckboxProps) => (
  <>
    {checked ?
      (
        <Svg
          color={color}
          width="18"
          height="18"
          viewBox="0 0 18 18"
          role="presentation"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 0H16C17.1 0 18 0.9 18 2V16C18 17.1 17.1 18 16 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0ZM12.56 5.5L13.62 6.56L7.68 12.5L4.5 9.32L5.56 8.26L7.68 10.38L12.56 5.5Z"
            fill="currentColor"
          />
        </Svg>
      ) :
      (
        <Svg
          color={color}
          width="18"
          height="18"
          viewBox="0 0 18 18"
          role="presentation"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="path-1-inside-1_358_496"
            fill="white"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z"
            />
          </mask>
          <path
            d="M16 -1H2V1H16V-1ZM2 -1C0.347715 -1 -1 0.347715 -1 2H1C1 1.45228 1.45228 1 2 1V-1ZM-1 2V16H1V2H-1ZM-1 16C-1 17.6523 0.347715 19 2 19V17C1.45228 17 1 16.5477 1 16H-1ZM2 19H16V17H2V19ZM16 19C17.6523 19 19 17.6523 19 16H17C17 16.5477 16.5477 17 16 17V19ZM19 16V2H17V16H19ZM19 2C19 0.347715 17.6523 -1 16 -1V1C16.5477 1 17 1.45228 17 2H19Z"
            fill="currentColor"
            mask="url(#path-1-inside-1_358_496)"
          />
        </Svg>
      )}
  </>
);
